// ─── Customer Endpoints ───────────────────────────────────────────────────────

export const API_GET_CUSTOMERS_URL = '/admin/getUsersWithFilter/';
export const API_GET_CUSTOMER = '/admin/getUserById/';
export const API_ADD_CUSTOMER = '/admin/addUser/';
export const API_EDIT_CUSTOMER = '/admin/editUser/';
export const API_DELETE_CUSTOMER = '/admin/removeUser/';
export const API_BLOCK_CUSTOMER = '/admin/blockUnblockUser/';
export const API_UPLOAD_CUSTOMER = '/user/importCsvList/';
export const API_CUSTOMER_LOGGED_OUT = '/admin/logoutUser/';
